import { styled, AppBar, Toolbar, Theme, useMediaQuery } from '@mui/material';
import { Brand, UserName } from '.';
import { IUser } from '..';
import { AuthButton } from '../../login';

export function Header(props: HeaderProps) {
  const matchesFullDeaBreakpoint = useMediaQuery('(min-width:37.5em)', {
    noSsr: true,
  });

  const matchesBrandBreakpoint = useMediaQuery('(min-width:60em)', {
    noSsr: true,
  });

  const smUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  return (
    <F1 position="static" color="primary">
      <F2>
        {matchesBrandBreakpoint && <Brand />}

        {!matchesFullDeaBreakpoint && <span>CSOS</span>}

        {matchesFullDeaBreakpoint && (
          <span>Controlled Substance Ordering System (CSOS)</span>
        )}

        {smUp ? null : <div style={{ flexGrow: 1 }}></div>}

        {props.user.isAuthenticated && (
          <UserName
            userName={`${props.user.firstName} ${props.user.lastName}`}
          />
        )}

        <AuthButton />
      </F2>
    </F1>
  );
}

interface HeaderProps {
  loading: boolean;
  user: IUser;
}

const F1 = styled(AppBar)({
  paddingLeft: '0px',
  paddingRight: '0px',
  boxShadow: 'none',
});

const F2 = styled(Toolbar)({
  justifyContent: 'space-between',
  fontSize: '1.8rem',

  '& *+*': {
    marginTop: '0em',
  },
});
